import { FormLabel, Stack, TextField, TextFieldProps } from "@mui/material";
import React, { forwardRef } from "react";
import { Controller, useFormContext } from "react-hook-form";

type Type_Props_TextField = TextFieldProps & {
    name: string;
};

const MuiTextField = forwardRef<HTMLInputElement, Type_Props_TextField>(
    ({ name, label, ...props }, ref) => {
        const { formState, control } = useFormContext();

        return (
            <Controller
                name={name}
                control={control}
                render={({ field: { ref: inputRef, ...rest } }) => (
                    <Stack gap={0.5}>
                        {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
                        <TextField
                            id={name}
                            {...rest}
                            {...props}
                            inputRef={ref || inputRef}
                            error={!!formState.errors[name]}
                            helperText={
                                formState?.errors[name]?.message as string
                            }
                        />
                    </Stack>
                )}
            />
        );
    },
);

MuiTextField.displayName = "MuiTextField";

export default MuiTextField;
